// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"cc7e09c1","369":"5c996578","402":"4d72467a","717":"675d3fa7","739":"de9e60a9","748":"9c01b34f","767":"457ab583","813":"350c55a2","821":"e23266ec","825":"735d4477","831":"d9d68550","875":"79f404e4","896":"6c741188","981":"137fece5"}[chunkId] + ".chunk.js";
};